import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.iovendosiciliano.it/api',
});

// Interceptor di REQUEST: aggiunge Authorization se c'è un token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor di RESPONSE: se riceviamo 401, tentiamo il refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          const { data } = await axios.post('https://api.iovendosiciliano.it/api/auth/refresh-token', { refreshToken });
          localStorage.setItem('token', data.accessToken);
          // Aggiorna il token nell'header della richiesta originale
          originalRequest.headers['Authorization'] = 'Bearer ' + data.accessToken;
          // Riprova la chiamata originale
          return axios(originalRequest);
        } catch (err) {
          // Se il refresh token fallisce, esegui logout o gestisci l'errore
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login'; 
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
